import { render } from "./NavBar_user.vue?vue&type=template&id=7afca6c0&scoped=true"
import script from "./NavBar_user.vue?vue&type=script&lang=js"
export * from "./NavBar_user.vue?vue&type=script&lang=js"

import "./NavBar_user.vue?vue&type=style&index=0&id=7afca6c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afca6c0"]])

export default __exports__